var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.037 0 0 4.037 0 9s4.037 9 9 9 9-4.037 9-9-4.038-9-9-9Zm0 16.699c-4.245 0-7.699-3.454-7.699-7.7 0-4.244 3.454-7.698 7.699-7.698 4.245 0 7.699 3.454 7.699 7.699 0 4.245-3.454 7.699-7.7 7.699Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.604 9.825h-.01l-1.943.03V4.767a.65.65 0 1 0-1.301 0V10.524c0 .027.005.052.008.077l.006.048c.006.028.016.054.025.08l.013.041c.012.027.027.051.041.076.007.011.012.023.02.034.016.024.035.046.055.068.008.009.015.02.024.028.02.02.044.038.068.056l.028.023a.63.63 0 0 0 .081.044c.01.005.019.011.029.015a.657.657 0 0 0 .102.032c.006.002.013.005.02.006a.665.665 0 0 0 .13.013h.01l2.604-.039a.651.651 0 0 0-.01-1.3Z",
    fill: "currentColor"
  })));
};

export default SvgClock;